import { getContext } from '@/context';

type ReturnType = {
  presetId: string | null;
};

const getPresetIdFromUrl = (): ReturnType => {
  try {
    const { params } = getContext().general.location.getState();
    const { presetId } = params;

    const presetIdValue = typeof presetId === 'string' ? presetId : null;

    return { presetId: presetIdValue };
  } catch {
    return { presetId: null };
  }
};

export { getPresetIdFromUrl };
